import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Col } from "react-bootstrap";
import { PAGE_OPTIONS } from '../../local_const/pageOptions.js';
import { CATEGORY_OPTIONS } from '../../local_const/categoryOptions.js';
import { storage, createCourse, updateCourse } from '../../firebase.js';
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import "../ResourceModal/ResourceModal.css"
import moment from 'moment';
import { BsTrash } from 'react-icons/bs';

const CreateActivity = (props) => {
    
    const course = props.course;
    const handleClose = props.close;
    const [courseTitle, setTitle] = useState(course.title || "");
    const [courseDes, setDes] = useState(course.description || "");
    const [courseImage, setImageUrl] = useState(course.image || null);
    const [date, setDate] = useState(course.date || "");
    const [courseCategory, setCategory] = useState(course.category || "");
    const [page, setPage] = useState(course.page || "");
    const [udemyUrl, setUdemyUrl] = useState(course.udemylink || "");
    const [youTubeUrl, setYouTubeUrl] = useState(course.youtubelink || "");
    const [otherUrl, setOtherUrl] = useState(course.otherlink || "");
    const [labelArr, setLabelLists] = useState(course.labels || []);
    const [isChecked, setIsChecked] = useState(false);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    
    useEffect(() => {
    setLabelLists(course.labels || []);
    }, [course.labels]);


    const setCoverUpload = (imageUpload) => {
        if (imageUpload === null) return;
        
        // Create a preview URL for the uploaded image
        const previewURL = URL.createObjectURL(imageUpload);
        setImagePreview(previewURL);

        const imageRef = ref(storage, `courses/${imageUpload.name}`);
        uploadBytes(imageRef, imageUpload)
            .then((snapshot) => {
            return getDownloadURL(snapshot.ref);
            })
            .then((url) => {
            setImageUrl(url);
            })
            .catch((error) => {
            console.error("Error uploading image:", error);
            alert("An error occurred while uploading the image. Please try again.");
            });
    };
    
    const handleDeleteUpload = () => {
        setUploadedFile(null);
        setImagePreview(null);
        setImageUrl(null);
        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) {
            fileInput.value = '';
        }
    };

    const createCourses = () => {
        if (courseTitle === "" || courseDes === "" || courseImage === null) {
          alert("Please fill in all required fields (Title, Description, and Image)");
          return;
        }
      
        const newCategory = courseCategory || "Waste Management";
        const newPage = page || "education";
      
        createCourse(
          courseTitle,
          courseDes,
          courseImage,
          date || new Date().toLocaleDateString("en-GB"),
          newCategory,
          labelArr,
          newPage,
          udemyUrl || null,
          youTubeUrl || null,
          otherUrl || null
        )
          .then(() => {
            handleClose();
            window.location.reload();
          })
          .catch((error) => {
            console.error("Error creating course:", error);
            alert("An error occurred while creating the course. Please try again.");
          });
      };
      
      const updateCourseInfo = () => {
        updateCourse(
          course.id,
          courseTitle,
          courseDes,
          date,
          courseCategory,
          labelArr,
          page,
          udemyUrl,
          youTubeUrl,
          otherUrl
        )
        .then(() => {
          handleClose();
          window.location.reload();
        })
        .catch((error) => {
          console.error("Error updating course:", error);
          alert("An error occurred while updating the course. Please try again.");
        });
      };

    const handleOnChange = () => {
        setIsChecked(!isChecked);
        setLabelLists(Object.entries(course.labels).map(([key, value]) => value));
    };
    
    const  handleLabelChange = (event) => { 
        const target = event.target
        const checked = target.checked
        const name = target.name
        const getFundOrgInfo = {name,checked};
        
        if (labelArr.filter((item) => item.name === name) && checked === true) {
            setLabelLists(prevArray => [...prevArray, getFundOrgInfo]);
        }else if(labelArr.filter((item) => item.name === name) && checked === false){
            setLabelLists(labelArr.filter((item) => item.name !== name));
        }else{
            setLabelLists(prevArray => [...prevArray, getFundOrgInfo])
        }

    }

    useEffect(() => {
        setTitle(course.title || "");
        setDes(course.description || "");
        setImageUrl(course.image || null);
        setDate(course.date || "");
        setCategory(course.category || "");
        setPage(course.page || "");
        setUdemyUrl(course.udemylink || "");
        setYouTubeUrl(course.youtubelink || "");
        setOtherUrl(course.otherlink || "");
        setLabelLists(course.labels || []);
      }, [course]);
      
    return (
        <>
            <Modal show={props.show} centered size="lg">
                <Modal.Header closeButton onClick={props.close}>
                    <Modal.Title>{props.status === "edit" ? "Edit Course" : "Add New Course"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-4 row">
                            <Form.Label className='col-md-4'>{props.status === "edit" ? "Update Title:" : "Course Title:"} <strong>*</strong></Form.Label>
                            <Col md={7} className='p-0'>
                                {props.status === "edit" ? (
                                <Form.Control type="text" placeholder="Enter Course Title" defaultValue={course.title} onChange={e => setTitle(e.target.value)} />
                                ) : (
                                <Form.Control type="text" placeholder="Enter Course Title" onChange={e => setTitle(e.target.value)} />
                                )}
                            </Col>
                        </Form.Group>
                        <Form.Group className="mb-4 row">
                            <Form.Label className='col-md-4'>{props.status === "edit" ? "Update Description :" : "Course Description :"}<strong>*</strong></Form.Label>
                            <Col md={7} className='p-0'>
                                {props.status === "edit" ? (
                                <Form.Control as="textarea" rows={3} placeholder="Enter Course Description" defaultValue={course.description} onChange={e => setDes(e.target.value)} />
                                ) : (
                                <Form.Control as="textarea" rows={3} placeholder="Enter Course Description" onChange={e => setDes(e.target.value)} />
                                )}
                            </Col>
                        </Form.Group>

                        
                        <Form.Group className="mb-4 row">
                            <Form.Label className='col-md-4'>{props.status === "edit" ? "Photo :" : "Upload Photo :"}<strong>*</strong></Form.Label>
                            <Col md={7} className='p-0'>
                                {props.status === "edit" ? (
                                <img src={course.image} className="border w-100" alt={course.image} />
                                ) : (
                                <>
                                    <Form.Group controlId="formFileSm" className="fileInput">
                                    <Form.Control type="file" onChange={(e) => { setCoverUpload(e.target.files[0]); }} />
                                    </Form.Group>
                                    {imagePreview && (
                                    <div className="mt-2 position-relative">
                                        <img src={imagePreview} alt="Upload preview" className="img-fluid mt-2 border" style={{maxHeight: '200px'}} />
                                        <Button variant="link" className="position-absolute bottom-0 end-0 m-1 text-danger" size="lg"  onClick={handleDeleteUpload}>
                                            <BsTrash />
                                        </Button>
                                    </div>
                                    )}
                                </>
                                )}
                            </Col>
                        </Form.Group>


                        <Form.Group className="mb-4 row">
                            <Form.Label className='col-md-4'>{props.status === "edit" ? "Update Date :" : "Add Date :"} <strong>*</strong></Form.Label>
                            <Col md={7} className="p-0"> 
                                {props.status === "edit" ? (
                                    <Form.Control  defaultValue={moment(course.date, "DD-MM-YYYY").locale('en').format('YYYY-MM-DD')} type="date" onChange={e => setDate(new Date(e.target.value).toLocaleDateString("en-GB"))} />
                                
                                ) : (
                                    <Form.Control type="date" onChange={e => setDate(new Date(e.target.value).toLocaleDateString("en-GB"))} />
                                )}
                             </Col>
                        </Form.Group>
                        <Form.Group className="mb-4 row">
                            <Form.Label className='col-md-4'>{props.status === "edit" ? "Update Category :" : "Add Category :"} <strong>*</strong></Form.Label>
                            <Col md={7} className='p-0'>
                                <Form.Select
                                    defaultValue={props.status === "edit" && course.category ? course.category : ""}
                                    onChange={e => setCategory(e.target.value)}
                                    aria-label="Select Category"
                                >
                                    {CATEGORY_OPTIONS.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Col>
                        </Form.Group>
                        <Form.Group className="mb-4 row">
                            <Form.Label className='col-md-4'> Add Label :  <strong>*</strong></Form.Label> 
                            {props.status === "edit" ? (
                                <Col md={7} className='p-0 row'> 
                                    {['waste',"development","marine", "geospatial", "geology","research","Community Economy"].map((label) => ( 
                                        <>
                                        {Object.values(labelArr === undefined ? [] : labelArr).map((item) => item.name).includes(label) === true ? ( 
                                                <div key={'org_'+label} className="mb-3 col-md-4"> 
                                                    <Form.Check
                                                        type="checkbox"
                                                        id={label}
                                                        label={label}
                                                        name={label}
                                                        checked={true}
                                                        onChange={e => handleLabelChange(e)}
                                                    />
                                                </div> 
                                                
                                            ) : (
                                                <div key={'org_'+label} className="mb-3 col-md-4"> 
                                                    <Form.Check
                                                        type="checkbox"
                                                        id={label}
                                                        label={label}
                                                        name={label} 
                                                        onChange={e => handleLabelChange(e)}
                                                    />
                                                </div> 
                                            )} 
                                        </>
                                    ))}
                                </Col>
                            ) : (
                                <Col md={7} className='p-0 row'> 
                                    {['waste',"development","marine", "geospatial", "geology","research","Community Economy"].map((label) => (
                                        <div key={label} className="mb-3 col-md-4">
                                            <Form.Check
                                                type="checkbox"
                                                id={label}
                                                label={label}
                                                name={label}
                                                onChange={e => handleLabelChange(e)}
                                            />
                                        </div>
                                    ))}
                                </Col>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-4 row">
                            <Form.Label className='col-md-4'>{props.status === "edit" ? "Update Page :" : "Add Page :"} <strong>*</strong></Form.Label>
                            <Col md={7} className='p-0'>
                                <Form.Select
                                    defaultValue={props.status === "edit" && course.page !== undefined ? course.page : ""}
                                    onChange={e => setPage(e.target.value)}
                                    aria-label="Select Your Page"
                                >
                                    {PAGE_OPTIONS.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Col>
                        </Form.Group>
                    
                        <Form.Group className="mb-4 row">
                        <Form.Label className='col-md-4'> Udemy : </Form.Label>
                        <Col md={7} className="p-0">
                            <Form.Control 
                            type="text" 
                            placeholder='Enter Udemy Link' 
                            value={udemyUrl}
                            onChange={e => setUdemyUrl(e.target.value)} 
                            />
                        </Col>
                        </Form.Group>

                        <Form.Group className="mb-4 row">
                        <Form.Label className='col-md-4'> YouTube : </Form.Label>
                        <Col md={7} className="p-0">
                            <Form.Control 
                            type="text" 
                            placeholder='Enter Youtube Link' 
                            value={youTubeUrl}
                            onChange={e => setYouTubeUrl(e.target.value)} 
                            />
                        </Col>
                        </Form.Group>

                        <Form.Group className="mb-4 row">
                        <Form.Label className='col-md-4'>Other Link : </Form.Label>
                        <Col md={7} className="p-0">
                            <Form.Control 
                            type="text" 
                            placeholder='Enter Additional Link' 
                            value={otherUrl}
                            onChange={e => setOtherUrl(e.target.value)} 
                            />
                        </Col>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    {props.status === "edit" ? (
                        <Button variant="primary" onClick={updateCourseInfo}> Update Course </Button>
                    ) : (
                        <Button variant="primary" onClick={createCourses}> Create Course </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    )
    
}

export default CreateActivity;